/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterOneAccountItemResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccountItems<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description List account items
   *
   * @tags account_items
   * @name GetAccountItems
   * @summary List the account items
   * @request GET:/account_items
   */
  getAccountItems = (
    query?: {
      "filter[ca_web_item_id]"?: number;
      "filter[code]"?: string;
      "filter[excise_id]"?: number;
      "filter[name]"?: string;
      "filter[search_key]"?: string;
      "filter[smb_item_id]"?: number;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneAccountItemResponse[];
      },
      PresenterError
    >({
      path: `/account_items`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
